window.onload = function() {

   /*
    * if Header-Sticky, then Header Sections Sticky
    */
  var hasHs = document.querySelector('body.has-header-sticky');
  if( hasHs ){
    var hs = document.querySelector('.header-sections');
    __addClassByObj(hs, 'js__header__stuck');
    hs.querySelector('.header__wrapper').style.position = 'inherit';
    document.querySelector('body').style.paddingTop = hs.clientHeight+ 'px';
  }

  /*
   * ShopTheLookSlideshow move into SlideshowLook Section
   */
  var sslk = document.getElementsByClassName('slideshow-look');
  var lkss = document.getElementsByClassName('index-look-slideshow');
  if( sslk.length ){
    __addClassByObj(sslk[0].parentElement, 'desktop');
    var vp = sslk[0].getElementsByClassName('flickity-viewport');
    // vp[0].style.maxHeight = vp[0].style.height;
    var sssl = sslk[0].getElementsByClassName('slideshow__slide');
    for (var s = 0; s < sssl.length; s++) {
      sssl[s].getElementsByClassName('hero__image')[0].style.display = 'none';
      sssl[s].getElementsByClassName('hero__content__wrapper')[0].style.display = 'none';
      if( lkss[s] ){
        var clone = lkss[s].cloneNode(true);
        clone.classList.remove('index-look-slideshow');
        clone.id = clone.id + '-' + (+ new Date());
        sssl[s].appendChild(clone);
      }
    }
  }
  for (var s = 0; s < lkss.length; s++) {
    // lkss[s].parentElement.style.display = 'none';
    __addClassByObj(lkss[s].parentElement, 'mobile');
  }
  
  /*
   * addEvent Open/Close Submenu
   */
  const objs = document.getElementsByClassName('expand-trigger');
  for (var i = 0, len = objs.length; i < len; i++) {
    /* onClick */
    objs[i].addEventListener("click", function(event) {
      var expcls= 'open';
      /* "open" class check */
      if( __isExistClassByObj(this, expcls) ){
        /* when open, close dropdown */
        __removeClassByObj(this, expcls);
      }
      else{
        /* when close, oepn dropdown */
        __addClassByObj(this, expcls);
      }
    }, false);
  }
  /*
   * addEvent Close Menu
   */
  var closers = document.getElementsByClassName('drawer__close');
  for (var i = 0, len = closers.length; i < len; i++) {
    closers[i].addEventListener("click", function(event) {
      var expcls= 'open';
      for (var n = 0, len = objs.length; n < len; n++) {
        /* remove "open" class */
        __removeClassByObj(objs[n], expcls);
      }      
    }, false);
  }

}; /* window.onload */


function __addClassByObj(obj,cls) {
  obj.className = obj.className + ' ' + cls;
}
function __addClassById(target,cls) {
  var el = __getObjById(target);
  if( el )
    __addClassByObj(el,cls);
}
function __removeClassByObj(obj,cls) {
  obj.className = obj.className.replace(cls, '');
}
function __removeClassById(target,cls) {
  var el = __getObjById(target);
  if( el )
    __removeClassByObj(el,cls);
}
function __isExistClassByObj(obj,cls){
  var clsArr = obj.className.split(' ');
  return clsArr.includes(cls);
}
function __removeClassSelector(target,cls){
  var els = document.querySelectorAll(target);
  if( els )
    for( var i=0; i<els.length; i++ ){
      els[i].classList.remove(cls);
    }
}
